export default __webpack_public_path__ + "static/media/benefit_11.999bd744.png";